module.exports = __webpack_public_path__ + "img/little_round_frame.8fcb76cc.png";